import type { Role } from '../../enums/auth/role.enum';

export function hasRoles(userRoles: Role[], requiredRoles: Role[] | undefined): boolean {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (!userRoles || userRoles.length === 0) {
    return false;
  }

  return requiredRoles.every((role) => userRoles.includes(role));
}
